/* eslint-disable @typescript-eslint/no-explicit-any */
import IconClose from '@assets/icons/close.svg?react';
import { IconButton, useTheme } from '@mui/material';
import MuiSnackbarContent from '@mui/material/SnackbarContent';
import { SnackbarContent, SnackbarProvider, useSnackbar } from 'notistack';
import { forwardRef, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';
import { clearToast } from '../../../redux/toast/toastSlice';
import MessageBox from './MessageBox';

const Notification = forwardRef((props: any, ref) => {
 const { closeSnackbar } = useSnackbar();
 const th = useTheme();
 const handleDismiss = useCallback(() => {
  closeSnackbar(props.id);
 }, [props.id, closeSnackbar]);

 const Action = (
  <IconButton size="small" onClick={handleDismiss}>
   <IconClose style={{ color: th.palette.kemek.white }} />
  </IconButton>
 );

 const bgColor = (variant: string) => {
  switch (variant) {
   case 'success':
    return th.palette.kemek.green;
   case 'warning':
    return th.palette.kemek.red;
   case 'error':
    return th.palette.kemek.red;
   case 'info':
    return th.palette.kemek.blue;
   default:
    return th.palette.kemek.blue;
  }
 };

 const MessageContent = (
  <div
   style={{
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
   }}
   dangerouslySetInnerHTML={{ __html: props.message }}
  />
 );

 return (
  <SnackbarContent ref={ref as any}>
   <MuiSnackbarContent
    message={MessageContent}
    action={Action}
    variant={props.variant}
    sx={{
     fontSize: 12,
     background: bgColor(props.variant),
     '& .MuiSnackbarContent-message': {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
     },
    }}
   />
  </SnackbarContent>
 );
});

Notification.displayName = 'Notification';

const Toast = () => {
 const toastRef = useRef<any>(null);
 const dispatch = useDispatch();

 const messages = useSelector((state: RootState) => state.toast.messages);

 const handleClose = (key: any) => {
  const currentSnack = toastRef.current.state.snacks.filter(
   (snack: any) => snack.id === key,
  );
  if (currentSnack?.[0]) {
   dispatch(clearToast(currentSnack[0].nanoid));
   // && !currentSnack[0].persist
   //    toastRef.current.closeSnackbar(key);
  }
 };

 return (
  <SnackbarProvider
   autoHideDuration={2000}
   ref={toastRef}
   dense
   preventDuplicate
   onClose={(event, reason, key) => {
    handleClose(key);
   }}
   maxSnack={4}
   anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
   }}
   Components={{
    default: Notification,
    error: Notification,
    info: Notification,
    success: Notification,
    warning: Notification,
   }}
  >
   {messages?.length ? <MessageBox messages={messages} /> : null}
  </SnackbarProvider>
 );
};

export default Toast;
